export const DELIVERY_SORT_OPTIONS = [
	{ value: "default", label: "Current" },
	{ value: "average_delivery_time", label: "Delivery" },
];
